import styled from '@emotion/styled';
import { colors } from '@anyroad/theme';

export const WaiverContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasError',
})<{
  hasError: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const WaiverCheckbox = styled.div<{ hasError: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border: ${(props) => (props.hasError ? `1px solid ${colors.error}` : 'none')};
  border-radius: 6px;
  background-color: ${colors.white};
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) =>
      props.hasError ? colors.error : colors.primary};
  }

  &:focus-within {
    border-color: ${colors.primary};
    box-shadow: 0 0 0 3px ${colors.primary}20;
  }
`;

export const CheckboxWrapper = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
`;

export const WaiverContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const WaiverText = styled.div`
  font-size: 14px;
  color: ${colors.text.primary};
  line-height: 1.4;
`;

export const WaiverLink = styled.span`
  color: ${colors.primary};
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    color: ${colors.primary};
    text-decoration: none;
  }
`;

export const WaiverSubtext = styled.div`
  font-size: 13px;
  color: ${colors.text.secondary};
  line-height: 1.4;
  margin-top: 4px;

  a {
    color: ${colors.primary};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const ErrorMessage = styled.div`
  color: ${colors.error};
  font-size: 13px;
  margin-top: 4px;
  padding: 6px 8px;
  background-color: ${colors.error}15;
  border: 1px solid ${colors.error}30;
  border-radius: 4px;
`;
